import React from 'react';
import { Eyebrow, Section } from './Section';
export function WhyNow() {
  return <Section tone="graphite" labelledBy="pourquoi-title" data-id="element-278" data-mp="rmr2icbnrvtt">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12" data-id="element-279" data-mp="rm90ez2bendz">
        <div className="lg:col-span-7" data-id="element-280" data-mp="15l8ni2a6iu81">
          <Eyebrow tone="dark" data-id="element-281" data-mp="15k5wzvgrqtsn">Le bon moment pour installer un cadre</Eyebrow>
          <h2 id="pourquoi-title" className="font-serif text-3xl font-semibold leading-[1.15] text-creme md:text-[2.75rem]" data-id="element-282" data-mp="11l6k9oospsqn">
            Avant votre prochain premier rendez-vous. Pas après le troisième
            décrochage.
          </h2>
        </div>

        <div className="lg:col-span-5" data-id="element-283" data-mp="mo7hce4w2o2i">
          <p className="max-w-prose text-base leading-relaxed text-creme/70 md:text-lg" data-id="element-284" data-mp="mp8tyn1jzimc">
            Le cadre se pose en Séance Zéro. Le creux de la quatrième séance se
            prépare dès la troisième. Chaque parcours qui commence sans feuille
            de route arrive à la séance 4 sans point rouge sur la carte.
          </p>
          <p className="mt-8 border-t border-warm-lineDark pt-8 font-serif text-xl italic leading-relaxed text-creme" data-id="element-285" data-mp="2zj5h2dnij8tg">
            Votre prochaine quatrième séance est peut-être déjà dans votre
            agenda.
          </p>
        </div>
      </div>
    </Section>;
}